import { render, staticRenderFns } from "./simOpen999.vue?vue&type=template&id=28ccd7fb&scoped=true&"
import script from "./simOpen999.vue?vue&type=script&lang=js&"
export * from "./simOpen999.vue?vue&type=script&lang=js&"
import style0 from "./simOpen999.vue?vue&type=style&index=0&id=28ccd7fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ccd7fb",
  null
  
)

export default component.exports